import { render, staticRenderFns } from "./Sharing.vue?vue&type=template&id=2b27386b&scoped=true&"
import script from "./Sharing.vue?vue&type=script&lang=js&"
export * from "./Sharing.vue?vue&type=script&lang=js&"
import style0 from "./Sharing.vue?vue&type=style&index=0&id=2b27386b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b27386b",
  null
  
)

export default component.exports